<div class="w-full max-w-320 mx-auto p-4 lg:p-8">

    <h2 class="text-3xl font-bold mb-3">Nowy produkt</h2>
    

    <div class="bg-card rounded-lg">
        <product-informations mode="CREATE"></product-informations>
    </div>

</div>